import IconRender from 'components/common/IconRender'
import { CustomColorsRef } from 'types/general'
import { VerificationStatus } from 'types/property'

const ListingVerificationBadge = ({
  verified,
}: {
  verified: VerificationStatus
}) => (
  <div
    className="relative flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/95 shadow-sm ring-1 ring-black/5"
    aria-hidden
  >
    {verified === VerificationStatus.Approved && (
      <IconRender
        icon="regular-shield-check"
        color={CustomColorsRef.Success}
      />
    )}
    {verified === VerificationStatus.Pending && (
      <IconRender icon="regular-shield" color={CustomColorsRef.Warning} />
    )}
    {verified === VerificationStatus.Rejected && (
      <IconRender
        icon="regular-shield-exclamation"
        color={CustomColorsRef.Danger}
      />
    )}
  </div>
)

export default ListingVerificationBadge
